export class MetodoPago {
    WAY_TO_PAY_ID: number;
    NAME: string;
    CASH: number;

    montoCorteCaja: number;
}



// WEBPACK FOOTER //
// ./src/app/models/metodo-pago.ts